require('intersection-observer');
import lozad from 'lozad';
const imagesLoaded = require('imagesloaded');

const closest = (el, targetClass) => {
  for (let item = el; item; item = item.parentElement) {
    if (item.classList.contains(targetClass)) {
      return item
    }
  }
}

export function lazyload() {
  const observer = lozad('.lozad', {
    rootMargin: '1000px 0px', // syntax similar to that of CSS Margin
    threshold: 0.1, // ratio of element convergence
    load: function(el) {
      const src = el.getAttribute('data-src');
      el.setAttribute('src', src);
      imagesLoaded(el, { background: true }, () => {
        el.classList.add('loaded');
        const parent = closest(el, 'js-lozad-parent');
        if(parent) {
          parent.classList.add('loaded');
        }
      });
    }
  });
  const observerBg = lozad('.lozad-bg', {
    load: function(el) {
      const src = el.getAttribute('data-src');
      el.style.backgroundImage = `url(${src})`; 
      imagesLoaded(el, { background: true }, () => {
        el.classList.add('loaded');
        const parent = closest(el, 'js-lozad-parent');
        if(parent) {
          parent.classList.add('loaded');
        }
      });
    }
  });
  const observerVideo = lozad('.lozad-video', {
    rootMargin: '1000px 0px', // syntax similar to that of CSS Margin
    threshold: 0.1, // ratio of element convergence
    load: function(el) {
      const src = el.getAttribute('data-src');
      const cls = el.getAttribute('data-class');
      const req = new XMLHttpRequest();
      req.open('GET', src, true);
      req.responseType = 'blob';
      req.onload = function() {
        if (this.status == 200) {
          const videoBlob = this.response;
          const video = URL.createObjectURL(videoBlob); // IE10+
          el.innerHTML = `<video muted playsinline><source src="${video}" type="video/mp4"></video>`;
          el.classList.add('loaded');
          const parent = closest(el, 'js-lozad-parent-video');
          if(parent) {
            if(cls) {
              parent.classList.add(cls);
            } else {
              parent.classList.add('loaded');
            }
          }
        }
      }
      req.onerror = function() { }
      req.send();
    }
  });
  observer.observe();
  observerBg.observe();

  observerVideo.observe();
}